module.exports = __webpack_public_path__ + "media/lobby_normal2.016b2ed1.mp3";